module.exports = __webpack_public_path__ + "static/media/art13.3fd90807.jpg";